export enum MODEL_KEY {
  ACTIVITY = "activity",
  ASSET = "asset",
  ASSETTYPE = "assettype",
  COMMENT = "comment",
  DATASET = "dataset",
  ENTITYTEMPLATE = "entitytemplate",
  INTERVENTION = "intervention",
  INTERVENTIONTEMPLATE = "interventiontemplate",
  JOBMODULE = "jobmodule",
  LOCATION = "location",
  MODULE = "module",
  OBSERVATION = "observation",
  ORGANIZATION = "organization",
  PROJECT = "project",
  RECOMMENDATION = "recommendation",
  ROLE = "role",
  SECTOR = "sector",
  SEVERITYGRID = "severitygrid",
  TECHNICALFORM = "technicalform",
  USER = "user",
}
